import { render, staticRenderFns } from "./create-order-detail-form.vue?vue&type=template&id=02866e5c&"
import script from "./create-order-detail-form.vue?vue&type=script&lang=js&"
export * from "./create-order-detail-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports